/** Where a tracker's number lives: the four settings that point at a cell range.
 *
 * Shared by the create and edit dialogs so the two can never drift — the first live
 * tracker created by somebody else read 0 of 31 for a week because the done value could
 * only be typed once, at creation, and the default did not match the sheet.
 */

import { Field, inputClass } from '@/components/ui'

export interface TrackerSource {
  source_path: string
  source_sheet: string
  source_status_column: string
  source_done_value: string
}

export function TrackerSourceFields({
  value,
  onChange,
}: {
  value: TrackerSource
  onChange: (key: keyof TrackerSource, next: string) => void
}) {
  return (
    <div className="card space-y-3 p-3">
      <p className="text-xs text-fg-muted">
        A tracker follows a count in a SharePoint spreadsheet. Give the site-relative path,
        not a share link — share links break when a file is moved or re-uploaded.
      </p>
      <Field label="Spreadsheet path" hint="e.g. PMT Documents/Windows 10/devices.xlsx">
        <input
          className={inputClass}
          value={value.source_path}
          onChange={(event) => onChange('source_path', event.target.value)}
        />
      </Field>
      <div className="grid grid-cols-3 gap-3">
        <Field label="Sheet" hint="Blank = first">
          <input
            className={inputClass}
            value={value.source_sheet}
            onChange={(event) => onChange('source_sheet', event.target.value)}
          />
        </Field>
        <Field label="Status column">
          <input
            className={inputClass}
            value={value.source_status_column}
            onChange={(event) => onChange('source_status_column', event.target.value)}
          />
        </Field>
        {/* The one that goes wrong. "Complete" and "Completed" are different values to the
            reader, and a mismatch is a silent zero, not an error. */}
        <Field label="Done value" hint="Exactly as the sheet spells it.">
          <input
            className={inputClass}
            value={value.source_done_value}
            onChange={(event) => onChange('source_done_value', event.target.value)}
          />
        </Field>
      </div>
    </div>
  )
}
